import React from "react";
import { FaUserCircle, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaPhone,
  FaEnvelope,
  FaCheckCircle,
} from "react-icons/fa";
import { IoMdShare } from "react-icons/io";
import { MdCall } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import {
  Vikas_logo,
  particle_bg1,
  vikasLogo,
  vikasLogo2,
} from "../../helper/imageConstant";
import { TiLocation } from "react-icons/ti";
const Ecard = ({ phoneNumber, image, name, number }) => {
  const message = encodeURIComponent("Hi"); // URL-encoded message

  return (
    <>
      {/* <div className="w-full h-screen relative overflow-hidden">
        <img
          src={image}
          alt="ecard"
          className="w-full h-full object-cover scale-[1.30]"
        />
        <div className="absolute bottom-[15%] left-0 right-0 flex items-center justify-center mx-auto my-2">
          <Link
            to={`https://wa.me/${phoneNumber}?text=${message}`}
            type="button"
            className="text-[#eee] text-sm flex items-center justify-center gap-2 bg-[#25D366] font-bold py-2 px-6 rounded hover:bg-[#2cb75f] capitalize"
          >
            <FaWhatsapp size={18} />
            whatsapp now
          </Link>
        </div>
      </div> */}

      <div className="relative min-h-screen font-sans shadow-lg  max-w-full md:max-w-full w-full h-full flex flex-col gap-2">
        <div className="w-full flex justify-center items-center">
          <Link to={"https://www.vikasfashion.com/"} className="mx-8">
            <img
              src={Vikas_logo}
              alt="logo"
              className="object-cover my-auto mx-auto"
            />
          </Link>
        </div>
        <div className="relative z-50">
          <div className="px-8">
            <Link
              to={`https://wa.me/${phoneNumber}?text=${message}`}
              type="button"
              className="w-full flex flex-col items-center justify-between
             bg-white border border-dashed border-[#A5312F] font-medium py-2 px-4 capitalize rounded-xl shadow-lg"
            >
              <p className="text-lg text-[#A5312F] uppercase">{name}</p>
              <p className="text-sm ">{number}</p>
            </Link>
          </div>
          <div className="flex flex-col justify-between p-8">
            <div className="flex flex-col gap-6">
              <div className="py-2 px-4 bg-[#F6BDC9] rounded-xl shadow-lg">
                <h1 className="text-center text-[12.5px] capitalize">
                  Manufacturers, Exporters, Importers of
                  <p className=" font-semibold text-[15.5px]">
                    Fancy Dyed Saress & Dress Materials
                  </p>
                </h1>
              </div>
              <div className="py-2 px-4 flex items-center gap-2.5 bg-white rounded-xl shadow-lg">
                <div className="bg-[#A5312F] p-2 rounded-full text-white">
                  <TiLocation className="" size={16} />
                </div>
                <div className="text-sm font-medium">
                  B 3033-34 Millennium Textile Market, Ring Road, Surat -
                  395002, Gujarat
                </div>
              </div>

              <div className="py-2 px-4 flex items-center gap-2.5 bg-white rounded-xl shadow-lg">
                <div className="bg-[#A5312F] p-2 rounded-full text-white">
                  <FaEnvelope className="" size={16} />
                </div>
                <div className="gap-2 flex items-center text-sm">
                  <p className="font-medium">sales@vikasfashion.com</p>
                </div>
              </div>
              <div className="py-2 px-4  bg-white rounded-xl shadow-lg">
                <div className="w-full flex items-start justify-start gap-2.5">
                  <div className="bg-[#A5312F] p-2 rounded-full text-white">
                    <MdCall className="" size={16} />
                  </div>
                  <div className="space-y-3">
                    <div className="gap-2 flex items-center text-sm">
                      <p className="font-semibold capitalize">Accounts</p>
                      <div className="flex gap-1 font-medium ">
                        <p>+91 99090 92729</p>
                      </div>
                    </div>
                    <div className="gap-2 flex items-start text-sm justify-between">
                      <p className="font-semibold capitalize">Sales</p>
                      <div className="flex flex-col gap-1 font-medium ">
                        <p>+91 95109 71377</p>
                        <p>+91 95109 71378</p>
                        <p>+91 99090 37418</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 z-0">
          <img src={particle_bg1} alt="" className="w-full h-full" />
        </div>
      </div>
    </>
  );
};

export default Ecard;
